export enum InputHighlight {
  CORRECT, DANGER, INFO
}

export interface CheckRadioProps {
  id: string,
  inputClassName?: string,
  label?: string,
  labelClassName?: string,
  layoutClassName?: string,
  name: string,
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void,
  options: string[],
  type: 'checkbox' | 'radio',
  value?: string
}

export interface InputFieldProps {
  defaultValue?: string,
  disabled?: boolean,
  helpMessage?: string,
  highlight?: InputHighlight,
  inputClassName?: string,
  label?: string,
  layoutClassName?: string,
  name: string,
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void,
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void,
  placeholder?: string,
  type: string,
  value?: string
}

export interface SelectProps {
  dataAttributes?: any,
  defaultFirstOption?: boolean,
  defaultValue?: string,
  helpMessage?: string,
  highlight?: InputHighlight,
  label?: string,
  layoutClassName?: string,
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void,
  options: string[],
  optionsClassName?: string,
  selectClassName?: string,
  value?: string
}



// WEBPACK FOOTER //
// ./src/types/components/Forms.ts